import { MonthlyData, CompanyMonthlyData } from '../types/dashboard';

export const formatCurrency = (num: number): string => {
  return `${(num / 100000000).toFixed(1)}억`;
};

export const formatNumber = (num: number): string => {
  return num.toLocaleString();
};

export const calculateTrendLine = (data: MonthlyData[]) => {
  if (data.length === 0) return data;
  return data.map((item) => ({
    ...item,
    trend: item.totalBilling
  }));
};

export const calculateAverage = (data: MonthlyData[]): number => {
  if (data.length === 0) return 0;
  const sum = data.reduce((acc, curr) => acc + curr.totalBilling, 0);
  return sum / data.length;
};

export const getTopCompanies = (data: CompanyMonthlyData[]): string[] => {
  const companyTotalMap: Record<string, number> = {};
  data.forEach(row => {
    companyTotalMap[row.company] = (companyTotalMap[row.company] || 0) + row.totalBilling;
  });
  return Object.entries(companyTotalMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10)
    .map(([company]) => company);
};

export const filterDataByDateRange = (
  data: (MonthlyData | CompanyMonthlyData)[],
  startMonth: string,
  endMonth: string
) => {
  return data.filter(row => row.month >= startMonth && row.month <= endMonth);
};

export const getTopItemSales = (data: { itemName: string; totalBilling: number }[]): { itemName: string; totalBilling: number }[] => {
  return data
    .sort((a, b) => b.totalBilling - a.totalBilling)
    .slice(0, 10);
}; 